import {CaretRight} from '@phosphor-icons/react'
import {useEffect, useState} from 'react'
import {useOccupancy} from '../../../../hooks/useOccupancy'
import {LayoutModel} from '../../../layout/models/layout.model'
import {KTableLoading} from '../../../../../../components/UI'

const NodeTree = ({node, selectedOption, TipoDataIn, dataGroup, ids = {}}: any) => {
  const {reportDayliData, getReportDayliList, getReportDayListHuesped, TipoData} = useOccupancy()
  const [isCampamentoExpanded, setIsCampamentoExpanded] = useState(false)
  const [dinamycId, setDinamicId] = useState<any>({})
  const [nodeIn, setNodeIn] = useState<LayoutModel | any>({})
  function getClassOpenTag() {
    let getReg = dataGroup.find((item) => item.tipo === TipoDataIn)
    let currentIndex = dataGroup.indexOf(getReg)
    let last = dataGroup.length
    if (TipoDataIn === 'EDC') {
      return `btn-icon btn btn-active-light ms-${currentIndex + 3} me-${
        currentIndex + 3
      } w-30px h-30px rounded-circle p-0`
    } else if (TipoDataIn === 'LOT') {
      return `btn-icon btn btn-active-light ms-${currentIndex + 3} me-${
        currentIndex + 3
      } w-30px h-30px rounded-circle p-0`
    } else if (TipoDataIn === 'CTH') {
      return `btn-icon btn btn-active-light ms-${currentIndex + 3} me-${
        currentIndex + 3
      } w-30px h-30px rounded-circle p-0`
    } else if (TipoDataIn === 'ENC') {
      return `btn-icon btn btn-active-light ms-${currentIndex + 3} me-${
        currentIndex + 3
      } w-30px h-30px rounded-circle p-0`
    } else if (TipoDataIn === 'MOD') {
      return `btn-icon btn btn-active-light ms-${last + 3} me-${
        currentIndex + 3
      } w-30px h-30px rounded-circle p-0`
    } else if (TipoDataIn === 'PIS') {
      return `btn-icon btn btn-active-light ms-${last + 5} me-${
        last + 3
      } w-30px h-30px rounded-circle p-0`
    } else if (TipoDataIn === 'HAB') {
      return `btn-icon btn btn-active-light ms-${last + 7} me-${
        last + 3
      } w-30px h-30px rounded-circle p-0`
    } else if (TipoDataIn === 'CAM') {
      return `btn-icon btn btn-active-light ms-${last + 9} me-${
        last + 3
      } w-30px h-30px rounded-circle p-0`
    } else if (TipoDataIn === 'HUE') {
      return `btn-icon btn btn-active-light ms-${last + 9} me-${
        last + 3
      } display-none w-30px h-30px rounded-circle p-0`
    } else {
      return `btn-icon btn btn-active-light me-1 w-30px h-30px rounded-circle p-0`
    }
  }

  const loadDinamicLayout = (type) => {
    let getReg = dataGroup.find((item) => item.tipo === type)
    let currentIndex = dataGroup.indexOf(getReg) // Por ejemplo, estamos en 'b'
    let nextValue = dataGroup[currentIndex + 1]
    let newType = currentIndex + 1 === dataGroup.length ? 'MOD' : nextValue.tipo
    getReportDayliList({
      TipoData: newType,
      FecEstadia: selectedOption.nroDiaFin,
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      HuespedId: selectedOption.HuespedDetId,
      EmpresaId: selectedOption.EmpresaId,
      ModuloId: selectedOption.ModuloId,
      HabitacionId: selectedOption.HabitacionId,
      CamaId: selectedOption.CamaId,
      CampamentoDetId: nodeIn.CampamentoId,
      EstadoCamaId: dinamycId?.EstadoCamaId ?? undefined,
      CategoriaHabitacionId: dinamycId?.CategoriaHabitacionId ?? undefined,
      EmpresaLotizacionId: dinamycId?.EmpresaId ?? undefined,
      EstadoNuevoCamaId: dinamycId?.EstadoNuevoCamaId ?? undefined,
    })
  }

  const loadModulesLayout = () => {
    getReportDayliList({
      TipoData: dataGroup.length === 0 ? 'MOD' : dataGroup[0].tipo,
      FecEstadia: selectedOption.nroDiaFin,
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      HuespedId: selectedOption.HuespedDetId,
      EmpresaId: selectedOption.EmpresaId,
      ModuloId: selectedOption.ModuloId,
      HabitacionId: selectedOption.HabitacionId,
      CamaId: selectedOption.CamaId,
      CampamentoDetId: nodeIn.CampamentoId,
      EstadoCamaId: dinamycId?.EstadoCamaId ?? undefined,
      CategoriaHabitacionId: dinamycId?.CategoriaHabitacionId ?? undefined,
      EmpresaLotizacionId: dinamycId?.EmpresaId ?? undefined,
      EstadoNuevoCamaId: dinamycId?.EstadoNuevoCamaId ?? undefined,
    })
  }

  const loadPisosLayout = () => {
    getReportDayliList({
      TipoData: 'PIS',
      FecEstadia: selectedOption.nroDiaFin,
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      HuespedId: selectedOption.HuespedDetId,
      EmpresaId: selectedOption.EmpresaId,
      ModuloId: selectedOption.ModuloId,
      HabitacionId: selectedOption.HabitacionId,
      CamaId: selectedOption.CamaId,
      CampamentoDetId: nodeIn.CampamentoId,
      ModuloDetId: nodeIn.ModuloId,
      EstadoCamaId: dinamycId?.EstadoCamaId,
      CategoriaHabitacionId: dinamycId?.CategoriaHabitacionId,
      EmpresaLotizacionId: dinamycId?.EmpresaId,
      EstadoNuevoCamaId: dinamycId?.EstadoNuevoCamaId,
    })
  }
  const loadHabitacionesLayout = () => {
    getReportDayliList({
      TipoData: 'HAB',
      FecEstadia: selectedOption.nroDiaFin,
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      HuespedId: selectedOption.HuespedDetId,
      EmpresaId: selectedOption.EmpresaId,
      ModuloId: selectedOption.ModuloId,
      HabitacionId: selectedOption.HabitacionId,
      CamaId: selectedOption.CamaId,
      CampamentoDetId: nodeIn.CampamentoId,
      ModuloDetId: nodeIn.ModuloId,
      PisoDetId: nodeIn.PisoId,
      EstadoCamaId: dinamycId?.EstadoCamaId,
      CategoriaHabitacionId: dinamycId?.CategoriaHabitacionId,
      EmpresaLotizacionId: dinamycId?.EmpresaId,
      EstadoNuevoCamaId: dinamycId?.EstadoNuevoCamaId,
    })
  }
  const loadCamasayout = () => {
    getReportDayliList({
      TipoData: 'CAM',
      FecEstadia: selectedOption.nroDiaFin,
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      HuespedId: selectedOption.HuespedDetId,
      EmpresaId: selectedOption.EmpresaId,
      ModuloId: selectedOption.ModuloId,
      HabitacionId: selectedOption.HabitacionId,
      CamaId: selectedOption.CamaId,
      CampamentoDetId: nodeIn.CampamentoId,
      ModuloDetId: nodeIn.ModuloId,
      PisoDetId: nodeIn.PisoId,
      HabitacionDetId: nodeIn.HabitacionId,
      EstadoCamaId: dinamycId?.EstadoCamaId,
      CategoriaHabitacionId: dinamycId?.CategoriaHabitacionId,
      EmpresaLotizacionId: dinamycId?.EmpresaId,
      EstadoNuevoCamaId: dinamycId?.EstadoNuevoCamaId,
    })
  }
  const loadHuespedesLayout = () => {
    getReportDayListHuesped({
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: nodeIn.CampamentoId,
      ModuloId: nodeIn.ModuloId,
      HabitacionId: nodeIn.HabitacionId,
      CamaId: nodeIn.CamaId,
      HuespedId: selectedOption.HuespedDetId,
      FechaDesde: selectedOption.nroDiaFin || '',
      FechaHasta: selectedOption.nroDiaFin || '',
    })
  }
  const handleCampamentoExpand = () => {
    setIsCampamentoExpanded(!isCampamentoExpanded)
    if (!isCampamentoExpanded) {
      switch (TipoDataIn) {
        case 'CAP':
          loadModulesLayout()
          break
        case 'EDC':
          setDinamicId((prevState) => ({...prevState, EstadoCamaId: nodeIn.EstadoCamaId}))
          // loadDinamicLayout('EDC')
          break
        case 'LOT':
          setDinamicId((prevState) => ({
            ...prevState,
            EmpresaId: nodeIn.LotizacionEmpresaId,
          }))

          // loadDinamicLayout('LOT')
          break
        case 'CTH':
          setDinamicId((prevState) => ({
            ...prevState,
            CategoriaHabitacionId: nodeIn.CategoriaHabitacionId,
          }))

          // loadDinamicLayout('CTH')
          break
        case 'ENC':
          setDinamicId((prevState) => ({...prevState, EstadoNuevoCamaId: nodeIn.EstadoNuevoCamaId}))

          // loadDinamicLayout('ENC')
          break
        case 'MOD':
          loadPisosLayout()
          break
        case 'PIS':
          loadHabitacionesLayout()
          break
        case 'HAB':
          loadCamasayout()
          break
        case 'CAM':
          loadHuespedesLayout()
          break
      }
    }
  }

  useEffect(() => {
    if (!reportDayliData || reportDayliData.length === 0) return
    if (TipoData === 'EDC') {
      setNodeIn({...nodeIn, beds: reportDayliData})
    }
    if (TipoData === 'LOT') {
      setNodeIn({...nodeIn, lots: reportDayliData})
    }
    if (TipoData === 'CTH') {
      setNodeIn({...nodeIn, categories: reportDayliData})
    }
    if (TipoData === 'ENC') {
      setNodeIn({...nodeIn, newBeds: reportDayliData})
    }
    if (TipoData === 'MOD') {
      setNodeIn({...nodeIn, modules: reportDayliData})
    }
    if (TipoData === 'PIS') {
      setNodeIn({...nodeIn, pisos: reportDayliData})
    }
    if (TipoData === 'HAB') {
      setNodeIn({...nodeIn, habitaciones: reportDayliData})
    }
    if (TipoData === 'CAM') {
      setNodeIn({...nodeIn, camas: reportDayliData})
    }
    if (TipoData === 'HUE') {
      setNodeIn({...nodeIn, huespedes: reportDayliData})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportDayliData])

  useEffect(() => {
    if (Object.keys(dinamycId).length > 0) {
      if (TipoDataIn === 'EDC') {
        loadDinamicLayout(TipoDataIn)
      }
      if (TipoDataIn === 'LOT') {
        loadDinamicLayout(TipoDataIn)
      }
      if (TipoDataIn === 'CTH') {
        loadDinamicLayout(TipoDataIn)
      }
      if (TipoDataIn === 'ENC') {
        loadDinamicLayout(TipoDataIn)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCampamentoExpanded, TipoDataIn])
  useEffect(() => {
    setNodeIn(node)
    setDinamicId(ids)
  }, [TipoDataIn])

  const getTipeArray = (type) => {
    let getReg = dataGroup.find((item) => item.tipo === type)
    let currentIndex = dataGroup.indexOf(getReg) // Por ejemplo, estamos en 'b'
    if (currentIndex >= 0 || type === 'CAP') {
      let isLast = currentIndex + 1 === dataGroup.length

      let obj = {tipo: 'MOD', name: 'modules'}
      let nextValue =
        dataGroup.length === 0 && type === 'CAP'
          ? obj
          : type === 'CAP'
          ? dataGroup[0]
          : isLast
          ? obj
          : dataGroup[currentIndex + 1]
      if (nextValue) {
        if (isCampamentoExpanded && nodeIn[nextValue.name] && TipoDataIn === type) {
          return (
            <>
              {nodeIn[nextValue.name].map((module: any) => {
                return (
                  <>
                    <NodeTree
                      key={TipoDataIn + '-' + node.ModuloId}
                      selectedOption={selectedOption}
                      node={module}
                      ids={dinamycId}
                      TipoDataIn={nextValue.tipo}
                      dataGroup={dataGroup}
                    />
                  </>
                )
              })}
            </>
          )
        }
      }
    }
  }
  return (
    <>
      <tr>
        <td>
          <button type='button' className={getClassOpenTag()} onClick={handleCampamentoExpand}>
            <CaretRight
              size={16}
              weight='bold'
              className={`${isCampamentoExpanded && 'animation-rotate-90'}`}
            />
          </button>
          {TipoDataIn === 'CAP' && (
            <span className={`${isCampamentoExpanded && 'fw-bold h5'}`}>
              {nodeIn.CampamentoNombre}
            </span>
          )}
          {TipoDataIn === 'EDC' && (
            <span className={`${isCampamentoExpanded && 'fw-bold h5'}`}>
              {nodeIn.EstadoCamaNombre}
            </span>
          )}
          {TipoDataIn === 'LOT' && (
            <span className={`${isCampamentoExpanded && 'fw-bolder h5'}`}>
              {nodeIn.LotizacionEmpresaNombre}
            </span>
          )}
          {TipoDataIn === 'CTH' && (
            <span className={`${isCampamentoExpanded && 'fw-bold h5'}`}>
              {nodeIn.CategoriaHabitacionNombre}
            </span>
          )}
          {TipoDataIn === 'ENC' && (
            <span className={`${isCampamentoExpanded && 'fw-bold h5'}`}>
              {nodeIn.EstadoNuevoCamaNombre}
            </span>
          )}
          {TipoDataIn === 'MOD' && (
            <span className={`${isCampamentoExpanded && 'fw-bold h5'}`}>
              {nodeIn.NomenclaturaModulo}
            </span>
          )}
          {TipoDataIn === 'PIS' && (
            <span className={`${isCampamentoExpanded && 'fw-bold h5'}`}>{nodeIn.PisoNombre}</span>
          )}
          {TipoDataIn === 'HAB' && (
            <span className={`${isCampamentoExpanded && 'fw-bold h5'}`}>
              {nodeIn.NomenclaturaHabitacion}
            </span>
          )}
          {TipoDataIn === 'CAM' && (
            <span className={`${isCampamentoExpanded && 'fw-bold h5'}`}>
              {nodeIn.NomenclaturaCama}
            </span>
          )}
          {TipoDataIn === 'HUE' && (
            <div className='d-flex flex-column'>
              {nodeIn.NroReserva && (
                <span className={`${isCampamentoExpanded && 'fw-bold'}`}>
                  Nro de reserva: {nodeIn.NroReserva}
                </span>
              )}
              {nodeIn.HuespedTipoDocNombre && nodeIn.HuespedNroDoc && (
                <span className={`${isCampamentoExpanded && 'fw-bold'}`}>
                  {nodeIn.HuespedTipoDocNombre + ' ' + nodeIn.HuespedNroDoc}
                </span>
              )}
              <span className={`${isCampamentoExpanded && 'fw-bold'}`}>
                {nodeIn.HuespedEmpresa}
              </span>
            </div>
          )}
        </td>
        <td>{nodeIn.TotalModulos}</td>
        <td>{nodeIn.TotalHabitaciones}</td>
        <td className={'border-gray-200'}>{TipoDataIn === 'CAM' ? '' : nodeIn.TotalCamas}</td>
        <td className={'border-gray-200'}>{nodeIn.TotalCamasCC}</td>
        <td className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
          {nodeIn.TotalCamas2} {TipoDataIn === 'CAM' ? 'Personas' : ''}
        </td>
        <td>{nodeIn.TotalHabitacionesOCU}</td>
        <td>{nodeIn.TotalHabitacionesDIS}</td>
        <td>{nodeIn.TotalHabitacionesRES}</td>
        <td>{nodeIn.TotalHabitacionesBLO}</td>
        <td>
          {nodeIn.TotalCamasOCU} {TipoDataIn === 'CAM' ? 'Personas' : ''}
        </td>
        <td>{nodeIn.TotalCamasDIS}</td>
        <td>{nodeIn.TotalCamasBLO}</td>
        <td className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
          {nodeIn.TotalCamasRES}
        </td>
        <td>
          {nodeIn.OcupacionHabitaciones !== null && nodeIn.OcupacionHabitaciones !== undefined
            ? `${(Number(nodeIn.OcupacionHabitaciones) * 100).toFixed(2)}%`
            : ''}
        </td>
        <td>
          {nodeIn.OcupacionCamas !== null && nodeIn.OcupacionCamas !== undefined
            ? `${(Number(nodeIn.OcupacionCamas) * 100).toFixed(2)}%`
            : ''}
        </td>
      </tr>
      {getTipeArray('CAP')}

      {getTipeArray('EDC')}

      {getTipeArray('LOT')}

      {getTipeArray('CTH')}

      {getTipeArray('ENC')}

      {isCampamentoExpanded && nodeIn.pisos && TipoDataIn === 'MOD' && (
        <>
          {nodeIn.pisos.map((piso: any) => (
            <>
              <NodeTree
                key={node.PisoId}
                selectedOption={selectedOption}
                node={piso}
                TipoDataIn={'PIS'}
                ids={dinamycId}
                dataGroup={dataGroup}
              />
            </>
          ))}
        </>
      )}
      {isCampamentoExpanded && nodeIn.habitaciones && TipoDataIn === 'PIS' && (
        <>
          {nodeIn.habitaciones.map((habitacion: any) => (
            <>
              <NodeTree
                key={node.HabitacionId}
                selectedOption={selectedOption}
                node={habitacion}
                TipoDataIn={'HAB'}
                ids={dinamycId}
                dataGroup={dataGroup}
              />
            </>
          ))}
        </>
      )}
      {isCampamentoExpanded && nodeIn.camas && TipoDataIn === 'HAB' && (
        <>
          {nodeIn.camas.map((cama: any) => (
            <>
              <NodeTree
                key={node.CamaId}
                selectedOption={selectedOption}
                node={cama}
                TipoDataIn={'CAM'}
                dataGroup={dataGroup}
              />
            </>
          ))}
        </>
      )}
      {isCampamentoExpanded && nodeIn.huespedes && TipoDataIn === 'CAM' && (
        <>
          {nodeIn.huespedes.map((huesped: any) => (
            <>
              <NodeTree
                key={node.HuespedId}
                selectedOption={selectedOption}
                node={huesped}
                TipoDataIn={'HUE'}
                dataGroup={dataGroup}
              />
            </>
          ))}
        </>
      )}
    </>
  )
}

export const TableReportOccupancy2 = ({
  selectedOption,
  dataGroup,
  setSearching,
  searching,
}: any) => {
  const [nodes, setNodes] = useState([])
  const {reportDayliData, getReportDayliList, isLoading} = useOccupancy()

  const loadCampsLayout = () => {
    getReportDayliList({
      TipoData: 'CAP',
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      FecEstadia: selectedOption.nroDiaFin,
      HuespedId: selectedOption.HuespedDetId,
      EmpresaId: selectedOption.EmpresaId,
      ModuloId: selectedOption.ModuloId,
      HabitacionId: selectedOption.HabitacionId,
      CamaId: selectedOption.CamaId,
    })
  }

  useEffect(() => {
    if (!reportDayliData || reportDayliData.length === 0) return
    setNodes(reportDayliData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportDayliData])

  useEffect(() => {
    if (searching) {
      setNodes([])
      loadCampsLayout()
      setTimeout(() => {
        setSearching(false)
      }, 2000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searching])

  return (
    <div className='p-6'>
      {isLoading && (
        <div className='position-relative h-100px'>
          <KTableLoading />
        </div>
      )}
      {nodes.length > 0 && (
        <div className='card card-custom'>
          <div className='card-body'>
            <div className='table-responsive'>
              <table className='table gs-7 gy-7 gx-7 table-row-bordered table-report-occupancy'>
                <thead>
                  <tr>
                    <th
                      rowSpan={2}
                      className={
                        'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                      }
                      style={{minWidth: '200px', borderRight: '1px solid black'}}
                    >
                      Nombre
                    </th>
                    <th
                      colSpan={5}
                      className={
                        'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                      }
                      style={{borderRight: '1px solid black'}}
                    >
                      TOTALES
                    </th>
                    <th
                      colSpan={7}
                      className={
                        'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                      }
                      style={{borderRight: '1px solid black'}}
                    >
                      DATOS
                    </th>
                    <th
                      colSpan={2}
                      className={
                        'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                      }
                    >
                      OCUPACIÓN
                    </th>
                  </tr>
                  <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                    <th>Módulos</th>
                    <th>Habitaciones</th>
                    <th>Camas Instaladas</th>
                    <th>Camas Calientes</th>
                    <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                      Camas Totales (C.I + C.C)
                    </th>
                    <th>Hbt. Ocupadas</th>
                    <th>Hbt. Disponibles</th>
                    <th>Hbt. Reservadas</th>
                    <th>Hbt. Bloqueadas</th>
                    <th>Camas Ocupadas</th>
                    <th>Camas Disponibles</th>
                    <th>Camas Bloqueadas</th>
                    <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                      Camas Reservadas
                    </th>
                    <th>% Ocup. Hbt.</th>
                    <th>% Ocup. Camas</th>
                  </tr>
                </thead>
                <tbody>
                  {nodes.map((node: any) => (
                    <NodeTree
                      key={node.CampamentoId}
                      selectedOption={{...selectedOption}}
                      node={node}
                      TipoDataIn={'CAP'}
                      dataGroup={dataGroup}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
